import React from "react";
import QueryString from "query-string";
import AppState from "./model/AppState";
import ObaTextField from "./components/ObaTextField";
import LogUtil from "./util/LogUtil";
import { FormControl, Snackbar, MenuItem } from "@material-ui/core";
import NavegadorUtil from "./util/NavegadorUtil";
import AlertaModel from "./model/AlertaModel";
import InputMask from "react-input-mask";
import C5UsuarioDAO from "./dataAccess/C5/C5UsuarioDAO";
import UsuarioCadastroModel from "./model/UsuarioCadastroModel";
import C5UsuarioEnderecoModel from "./model/C5UsuarioEnderecoModel";
import UsuarioModel from "./model/UsuarioModel";
import ObaUsuarioDAO from "./dataAccess/Oba/ObaUsuarioDAO";
import ObaUsuarioCadastroModel from "./model/ObaUsuarioCadastroModel";
import WPPaginaModel from "./model/WPPaginaModel";
import WPPaginaDAO from "./dataAccess/WP/WPPaginaDAO";
import ModalPolitica from "./components/ModalPolitica";
import Rodape from "./components/Rodape";
import { ReactComponent as ImagemMenuBack } from "./assets/images/icons/menu-back.svg";
import StringUtil from "./util/StringUtil";
import Carregando from "./components/Carregando";
import { RouteComponentProps, withRouter } from "react-router-dom";

import LogoBemQuerer from "./assets/images/img_logo_bem_querer.svg";
import ProxyCacheDAO from "./dataAccess/Proxy/ProxyCacheDados";
import UsuarioEnderecoModel from "./model/UsuarioEnderecoModel";

interface ICadastreseProps extends RouteComponentProps {}

type CadastreseState = {
  nome: string;
  sobrenome: string;
  telefone: string;
  cpf: string;
  dataNascimento: string;
  cep: string;
  logradouro: string;
  numero: string;
  complemento: string;
  complementoFlag: boolean;
  bairro: string;
  cidade: string;
  uf: string;
  email: string;
  confirmacaoEmail: string;
  senha: string;
  sexo: string;
  confirmacaoSenha: string;
  consultouCEP: boolean;
  usuarioEndereco: C5UsuarioEnderecoModel | null;
  carregando: boolean;
  concluido: boolean;
  aceitacao: boolean;
  politicas: WPPaginaModel[];
  modalPoliticas: boolean;
  carregouUsuario: boolean;
  camposAcessados: string[];
  step: number;
};

class Cadastrese extends React.Component<ICadastreseProps, CadastreseState> {
  
  naoTemComplemento: string = "NAO TEM COMPLEMENTO";
  
  constructor(props: ICadastreseProps) {
    super(props);

    this.cadastrar = this.cadastrar.bind(this);
    this.validaFormulario = this.validaFormulario.bind(this);
    this.verificaUsuarioLogado = this.verificaUsuarioLogado.bind(this);
    this.exibirTermos = this.exibirTermos.bind(this);
    this.ocultarPolitica = this.ocultarPolitica.bind(this);
    this.validaCEP = this.validaCEP.bind(this);

    this.state = {
      nome: "",
      sobrenome: "",
      telefone: "",
      cpf: "",
      dataNascimento: "",
      cep: "",
      logradouro: "",
      numero: "",
      complemento: "",
      complementoFlag: false,
      bairro: "",
      cidade: "",
      uf: "",
      email: "",
      confirmacaoEmail: "",
      senha: "",
      sexo: "",
      confirmacaoSenha: "",
      consultouCEP: false,
      usuarioEndereco: null,
      carregando: false,
      concluido: false,
      aceitacao: false,
      politicas: [],
      modalPoliticas: false,
      carregouUsuario: false,
      camposAcessados: [],
      step: 1,
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Login");
    this.verificaUsuarioLogado();

    WPPaginaDAO.getInstance()
      .getPolPrivBQ()
      .then((politicas) => {
        this.setState({ politicas });
      });
  }

  verificaUsuarioLogado(): void {
    const query: any = QueryString.parse(this.props.location.search);
    const usuario: UsuarioModel | null = AppState.getUsuarioLogado();

    if (usuario !== null) {

      let nome: string = "";
      let sobrenome: string = "";

      if (usuario.nome.indexOf(" ") > 0) {
        nome = usuario.nome.substr(0, usuario.nome.indexOf(" "));
        sobrenome = usuario.nome.substr(usuario.nome.indexOf(" ") + 1);
      }

      this.setState({
        carregando: true,
        nome,
        sobrenome,
        cpf: usuario.documento,
        sexo: usuario.sexo,
        telefone: usuario.telefone,
        email: usuario.email,
        confirmacaoEmail: usuario.email,
        dataNascimento: usuario.nascimento,
      });

      C5UsuarioDAO.getInstance().buscaUsuarioEnderecoCompleto(
        +usuario.clienteId
      ).then(async (usuarioEnderecoC5: UsuarioEnderecoModel | null) => {

        if (usuarioEnderecoC5) {
          let cep: string = usuarioEnderecoC5.cep.toString();
          if (cep.length !== 8) {
            cep = cep.padStart(8, "0");
          }

          if (usuario.clienteEnderecoId > 0
            && query.returnUrl
            && query.returnUrl.length > 0
            && usuarioEnderecoC5.complemento
            && usuarioEnderecoC5.complemento.length > 0) {
            NavegadorUtil.redirect(query.returnUrl, this.props.history);
          }
    

          this.setState({
            numero: usuarioEnderecoC5.numero,
            cep,
            carregando: false,
            complemento: usuarioEnderecoC5.complemento,
            complementoFlag: (usuarioEnderecoC5.complemento === this.naoTemComplemento),
            carregouUsuario: true,
          });

          await this.validaCEP(cep);
          
          const { logradouro, bairro } = this.state;
          if (!logradouro || (logradouro.length < 3)) {
            this.setState({ logradouro: usuarioEnderecoC5.endereco });
          }
          if (!bairro || (bairro.length < 3)) {
            this.setState({ bairro: usuarioEnderecoC5.bairro });
          }
        } else {

          let cep = "";
          if (usuario.cep) {
            cep = usuario.cep.toString();
            if (cep.length !== 8) {
              cep = cep.padStart(8, "0");
            }
          }

          this.setState({
            nome,
            sobrenome,
            cep,
            cpf: usuario.documento,
            sexo: usuario.sexo,
            telefone: usuario.telefone,
            carregando: false,
            email: usuario.email,
            dataNascimento: usuario.nascimento,
            carregouUsuario: true,
          });

          this.setState({ carregando: false });

          await this.validaCEP(cep);
        }
      });
    }
  }

  async cadastrar(): Promise<void> {
    if (this.validaFormulario()) {
      const {
        nome,
        sobrenome,
        telefone,
        cpf,
        email,
        senha,
        sexo,
        numero,
        cep,
        uf,
        complemento,
        cidade,
        bairro,
        usuarioEndereco,
        dataNascimento,
        logradouro,
        complementoFlag,
      } = this.state;

      const dataPadrao: string = "01/01/2010";
      const dataNascimentoAPI: Date =
        dataNascimento.length > 8
          ? new Date(
              +dataNascimento.split("/")[2],
              +dataNascimento.split("/")[1] - 1,
              +dataNascimento.split("/")[0]
            )
          : new Date(dataPadrao);
      const sexoAPI: string = sexo !== "F" ? "M" : "F";

      const telefoneTratado: string = telefone
        .replace(/\(/g, "")
        .replace(/\)/g, "")
        .replace(/-/g, "")
        .replace(/ /g, "");
      const cpfTratado: string = cpf.replace(/\./g, "").replace(/-/g, "");

      const usuario: UsuarioCadastroModel = {
        documento: String(cpfTratado.trim()).padStart(11, '0'),
        email,
        nascimento: dataNascimentoAPI.toLocaleDateString("pt-BR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
        nome: nome + " " + sobrenome,
        senha,
        telefone: telefoneTratado,
        sexo: sexoAPI,
        facebookId: "",
        googleId: "",
      } as UsuarioCadastroModel;

      const obaUsuario: ObaUsuarioCadastroModel = {
        CEP: cep,
        Cidade: cidade,
        Complemento: complemento,
        Cpf: String(cpf.trim()).padStart(11, '0'),
        Email: email,
        Estado: uf,
        Logradouro: logradouro,
        Bairro: bairro,
        Nascimento: dataNascimentoAPI.toLocaleDateString("pt-BR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
        Nome: nome + " " + sobrenome,
        Numero: numero,
        Sexo: sexo,
        Telefone: telefoneTratado,
      } as ObaUsuarioCadastroModel;

      const usuarioLogado: UsuarioModel | null = AppState.getUsuarioLogado();

      if (usuarioLogado) {
        this.setState({ carregando: true }, () => {
          const usuarioAtualizado = {
            documento: String(usuarioLogado.documento.trim()).padStart(11, '0'),
            email: usuarioLogado.email,
            nascimento: dataNascimento.replace(/-/g, "/"),
            nome: nome + " " + sobrenome,
            sexo: sexoAPI,
            telefone: telefoneTratado,
            facebookId: "",
            googleId: "",
            senha,
            usuarioId: usuarioLogado.clienteId,
          } as UsuarioCadastroModel;
          C5UsuarioDAO.getInstance()
            .atualizaUsuario(usuarioAtualizado)
            .then(() => {
              AppState.setMaioridade(false);
              
              const cepTratado: string = cep
                .replace(/-/g, "")
                .replace(/_/g, "");

              if (usuarioEndereco) {
                usuarioEndereco.ClientID = +usuarioLogado.clienteId;
                usuarioEndereco.Number = +numero;
                usuarioEndereco.ZipCode = cepTratado;
                usuarioEndereco.Complement = complementoFlag ? this.naoTemComplemento : complemento;
                usuarioEndereco.Description = "Cadastro pelo site";
                usuarioEndereco.Address = logradouro;
                usuarioEndereco.Neighborhood = bairro;
                usuarioEndereco.CompleteAddress =
                  usuarioEndereco.StreetAddress +
                  ", " +
                  usuarioEndereco.Number.toString();

                C5UsuarioDAO.getInstance()
                  .atualizaUsuarioEndereco(usuarioEndereco)
                  .then(() => {
                    ObaUsuarioDAO.getInstance()
                      .cadastraUsuario(obaUsuario)
                      .then(() => {
                        this.setState(
                          {
                            carregando: false,
                          },
                          async () => {
                            if (senha.length > 4) {
                              usuario.usuarioId = usuarioLogado.clienteId;
                              await ProxyCacheDAO.getInstance().postDadosUsuario(
                                usuario
                              );
                            }

                            try {
                              await ObaUsuarioDAO.getInstance().cadastraUsuario({
                                Nome: nome + " " + sobrenome,
                                Email: email,
                                Cpf: String(cpf.trim()).padStart(11, '0'),
                                Telefone: telefoneTratado,
                                Bairro: bairro,
                                Cidade: cidade,
                                Estado: uf,
                                Sexo: sexoAPI,
                                Logradouro: usuarioEndereco.StreetAddress,
                                CEP: cepTratado,
                                Complemento: complementoFlag ? this.naoTemComplemento : complemento,
                                Numero: usuarioEndereco.Number?.toString(),
                                Nascimento: dataNascimento.replace(/-/g, "/"),
                              } as ObaUsuarioCadastroModel);
                            } catch (ex) {
                            }

                            NavegadorUtil.alerta(
                              this,
                              "Usuário atualizado com sucesso"
                            );

                            AppState.setUsuarioLogado({
                              email: usuarioAtualizado.email,
                              clienteId: usuarioLogado.clienteId,
                              clienteEnderecoId: usuarioEndereco.ClientAddressID,
                              cep: cepTratado,
                              nome: usuarioAtualizado.nome,
                              documento: String(usuarioAtualizado.documento.trim()).padStart(11, '0'),
                              sexo: usuarioAtualizado.sexo,
                              telefone: usuarioAtualizado.telefone,
                              nascimento: usuarioAtualizado.nascimento,
                              googleId: "",
                              facebookId: "",
                              senha: "",
                            } as UsuarioModel);
                          }
                        );
                      })
                      .catch(() => {
                        NavegadorUtil.alerta(
                          this,
                          "Erro ao atualizar usuário - [Erro: user:oba]"
                        );
                      });
                  })
                  .catch(() => {
                    NavegadorUtil.alerta(
                      this,
                      "Erro ao atualizar usuário - [Erro: address:c5]"
                    );
                  });
              }
            })
            .catch(() => {
              NavegadorUtil.alerta(
                this,
                "Erro ao atualizar usuário - [Erro: user:c5]"
              );
            });
        });
      } else {
        this.setState({ carregando: true }, () => {
          C5UsuarioDAO.getInstance()
            .cadastrarUsuario(usuario)
            .then(async (c) => {
              if (usuarioEndereco) {
                const cepTratado: string = cep
                  .replace(/-/g, "")
                  .replace(/_/g, "");

                usuarioEndereco.ClientID = c.data.ClientID.toString();
                usuarioEndereco.Number = +numero;
                usuarioEndereco.ZipCode = cepTratado;
                usuarioEndereco.Description = "Cadastro pelo site";
                usuarioEndereco.Complement = complementoFlag ? this.naoTemComplemento : complemento;
                usuarioEndereco.Address = usuarioEndereco.StreetAddress;
                usuarioEndereco.CompleteAddress =
                  usuarioEndereco.StreetAddress +
                  ", " +
                  usuarioEndereco.Number.toString();

                C5UsuarioDAO.getInstance()
                  .cadastrarUsuarioEndereco(usuarioEndereco)
                  .then(async () => {
                    await ObaUsuarioDAO.getInstance().cadastraUsuario(
                      obaUsuario
                    );

                    usuario.usuarioId = c.data.ClientID.toString();
                    await ProxyCacheDAO.getInstance().postDadosUsuario(usuario);

                    try {
                      await ObaUsuarioDAO.getInstance().cadastraUsuario({
                        Nome: nome + " " + sobrenome,
                        Email: email,
                        Cpf: String(cpf.trim()).padStart(11, '0'),
                        Telefone: telefoneTratado,
                        Bairro: bairro,
                        Cidade: cidade,
                        Estado: uf,
                        Sexo: sexoAPI,
                        Logradouro: usuarioEndereco.StreetAddress,
                        CEP: cepTratado,
                        Complemento: complementoFlag ? this.naoTemComplemento : complemento,
                        Numero: usuarioEndereco.Number?.toString(),
                        Nascimento: dataNascimento.replace(/-/g, "/"),
                      } as ObaUsuarioCadastroModel);
                    } catch (ex) {
                    }

                    NavegadorUtil.alerta(
                      this,
                      "Cadastro efetuado com sucesso ! Redirecionando..."
                    );
                    setTimeout(() => {
                      const query: any = QueryString.parse(
                        this.props.location.search
                      );
                      if (query.returnUrl && query.returnUrl.length > 0) {
                        NavegadorUtil.redirect(
                          `/login?returnUrl=${query.returnUrl}`,
                          this.props.history
                        );
                      } else {
                        NavegadorUtil.redirect("/login", this.props.history);
                      }
                    }, 3000);
                  })
                  .catch(async (ex) => {
                    NavegadorUtil.alerta(
                      this,
                      `Erro ao cadastrar o usuário [${ex.response.data.ExceptionMessage}].`
                    );
                    this.setState({ carregando: false, concluido: true });
                  });
              }
            })
            .catch(async (err) => {
              NavegadorUtil.alerta(
                this,
                `Erro ao cadastrar o usuário [${err.response.data.ExceptionMessage}].`
              );
              this.setState({ carregando: false, concluido: true });
            });
        });
      }
    }
  }

  validaFormulario(): boolean {
    const {
      nome,
      sobrenome,
      telefone,
      cpf,
      cep,
      logradouro,
      numero,
      complemento,
      complementoFlag,
      cidade,
      uf,
      email,
      confirmacaoEmail,
      senha,
      confirmacaoSenha,
      bairro,
      aceitacao,
      carregouUsuario,
      dataNascimento,
      step,
      consultouCEP,
    } = this.state;

    const regexpEspeciais = /[~!@#$%^&*+={}|/><.,]/g;
    const regexpNumeros = /^[0-9]+/;

    // VALIDA STEP 1
    if ( step === 1 ) {
  
      const nomeSanitizado = StringUtil.sanitizaCadastro(nome);

      if (nomeSanitizado.length === 0) {
        NavegadorUtil.alerta(this, "Preencha o campo nome");
        return false;
      }
  
      if (nome.length < 3) {
        NavegadorUtil.alerta(this, "Preencha o campo nome com pelo menos três caracteres");
        return false;
      }

      if (nome.match(regexpEspeciais)) {
        NavegadorUtil.alerta(this, "Preencha o campo nome sem usar caracteres especiais");
        return false;
      }

      if (nome.match(regexpNumeros)) {
        NavegadorUtil.alerta(this, "Não é permitido preencher o campo nome somente com números");
        return false;
      }

      if (nomeSanitizado.length < 3) {
        NavegadorUtil.alerta(this, "Preencha o campo nome com pelo menos três caracteres");
        return false;
      }

      if (StringUtil.sanitizaCadastro(sobrenome).length === 0) {
        NavegadorUtil.alerta(this, "Preencha o campo sobrenome");
        return false;
      }
  
      if (sobrenome.length < 3) {
        NavegadorUtil.alerta(this, "Preencha o campo sobrenome com pelo menos três caracteres");
        return false;
      }

      if (sobrenome.match(regexpEspeciais)) {
        NavegadorUtil.alerta(this, "Preencha o campo sobrenome sem usar caracteres especiais");
        return false;
      }

      if (sobrenome.match(regexpNumeros)) {
        NavegadorUtil.alerta(this, "Não é permitido preencher o campo sobrenome somente com números");
        return false;
      }

      if (StringUtil.sanitizaCadastro(telefone).length === 0) {
        NavegadorUtil.alerta(this, "Preencha o campo telefone");
        return false;
      }
  
      if (StringUtil.sanitizaCadastro(telefone.replace(/[-_ ]/g, '')).length < 11) {
        NavegadorUtil.alerta(this, "Preencha corretamente o campo telefone");
        return false;
      }

      if (StringUtil.sanitizaCadastro(cpf).length === 0) {
        NavegadorUtil.alerta(this, "Preencha o campo CPF");
        return false;
      }
  
      if (!StringUtil.validaCPF(cpf)) {
        NavegadorUtil.alerta(this, "CPF inválido");
        return false;
      }
  
  
      if (StringUtil.sanitizaCadastro(dataNascimento).length === 0) {
        NavegadorUtil.alerta(this, "Preencha o campo 'Data de nascimento'");
        return false;
      }
  
      if (dataNascimento.replace(/[/\-_]/g, '').length !== 8) {
        NavegadorUtil.alerta(this, "Preencha corretamente o campo 'Data de nascimento'");
        return false;
      }
  
      try {
        const nasc: Date = new Date(
          +dataNascimento.split("/")[2],
          +dataNascimento.split("/")[1] - 1,
          +dataNascimento.split("/")[0]
        );
  
        if (nasc > new Date() || nasc < new Date(1900, 1, 1)) {
          NavegadorUtil.alerta(this, "Informe em 'Data de nascimento' uma data entre 1900 e hoje");
          return false;
        }
      } catch(exNascimento) {
        NavegadorUtil.alerta(this, "Preencha corretamente o campo 'Data de nascimento'");
        return false;
      }
  
      return true;
    // VALIDA STEP 2
    } else if ( step === 2 ) {
      if (cep.replace(/[-_]/g, '').length !== 8) {
        NavegadorUtil.alerta(this, "Preencha o campo CEP");
        return false;
      }

      if (!consultouCEP) {
        NavegadorUtil.alerta(this, "É necessário identificar um endereço pelo CEP para efetivar o cadastro.");
        return false;
      }
  
      if (logradouro.length === 0) {
        NavegadorUtil.alerta(this, "Preencha o campo logradouro");
        return false;
      }
  
      if (numero === null) {
        NavegadorUtil.alerta(this, "Preencha o campo numero");
        return false;
      }
      
      if (numero.trim().length === 0) {
        NavegadorUtil.alerta(this, "Preencha o campo numero");
        return false;
      }

      if (numero.match(regexpEspeciais)) {
        NavegadorUtil.alerta(this, "Preencha o campo numero sem usar caracteres especiais");
        return false;
      }

      if ((!complemento || (complemento && complemento.length === 0)) && !complementoFlag) {
        NavegadorUtil.alerta(this, "Informe um complemento ou selecione a opção informando que seu endereço não possui complemento.");
        return false;
      }

      if (bairro.trim().length === 0) {
        NavegadorUtil.alerta(this, "Preencha o campo bairro");
        return false;
      }
  
      if (bairro.trim().length < 4) {
        NavegadorUtil.alerta(this, "Preencha o campo bairro com pelo menos 3 caracteres");
        return false;
      }
  
      if (bairro.match(regexpEspeciais)) {
        NavegadorUtil.alerta(this, "Preencha o campo bairro sem usar caracteres especiais");
        return false;
      }

      if (bairro.match(regexpNumeros)) {
        NavegadorUtil.alerta(this, "Não é permitido preencher o campo bairro somente com números");
        return false;
      }

      if (cidade.trim().length === 0) {
        NavegadorUtil.alerta(this, "Preencha o campo cidade");
        return false;
      }
  
      if (cidade.trim().length < 4) {
        NavegadorUtil.alerta(this, "Preencha o campo cidade com pelo menos 3 caracteres");
        return false;
      }

      if (cidade.match(regexpEspeciais)) {
        NavegadorUtil.alerta(this, "Preencha o campo cidade sem usar caracteres especiais");
        return false;
      }

      if (cidade.match(regexpNumeros)) {
        NavegadorUtil.alerta(this, "Não é permitido preencher o campo cidade somente com números");
        return false;
      }

      if (uf.trim().length === 0) {
        NavegadorUtil.alerta(this, "Preencha o campo UF");
        return false;
      }

      if (uf.trim().length !== 2) {
        NavegadorUtil.alerta(this, "Preencha o campo UF com 2 caracteres ex: 'SP'");
        return false;
      }

      if (uf.match(regexpEspeciais)) {
        NavegadorUtil.alerta(this, "Preencha o campo UF sem usar caracteres especiais");
        return false;
      }

      return true;

    // VALIDA STEP 3
    } else if ( step === 3 ) {
      if (email.length === 0) {
        NavegadorUtil.alerta(this, "Preencha o campo email");
        return false;
      }
  
      if (!StringUtil.emailValido(email)) {
        NavegadorUtil.alerta(this, "E-mail preenchido com formato inválido");
        return false;
      }

      if (email !== confirmacaoEmail) {
        NavegadorUtil.alerta(
          this,
          "E-mail e confirmação de e-mail não coincidem."
        );
        return false;
      }

      if ((carregouUsuario && senha.length > 0) || !carregouUsuario) {
        if (senha.length === 0) {
          NavegadorUtil.alerta(this, "Preencha o campo senha");
          return false;
        }
  
        if (confirmacaoSenha.length === 0) {
          NavegadorUtil.alerta(this, "Preencha o campo Confirmação de senha");
          return false;
        }
  
        if (senha !== confirmacaoSenha) {
          NavegadorUtil.alerta(
            this,
            "Senha e confirmação de senha não coincidem."
          );
          return false;
        }
  
        if (senha.length < 8) {
          NavegadorUtil.alerta(this, "A senha deve ter no mínimo 8 caracteres.");
          return false;
        }
  
        if (!/[A-Z]/.test(senha)) {
          NavegadorUtil.alerta(
            this,
            "A senha deve ter no mínimo um caractere maiúsculo."
          );
          return false;
        }
  
        if (!/[a-z]/.test(senha)) {
          NavegadorUtil.alerta(
            this,
            "A senha deve ter no mínimo um caractere minúsculo."
          );
          return false;
        }
  
        if (!/\d/.test(senha)) {
          NavegadorUtil.alerta(this, "A senha deve ter no mínimo um número.");
          return false;
        }
      }
  
      if (!aceitacao) {
        NavegadorUtil.alerta(
          this,
          "Você deve aceitar nossos termos para fazer o cadastro"
        );
        return false;
      }

      return true;
    }
    return false;
  }

  exibirTermos(): any {
    this.setState({ modalPoliticas: true });
  }

  ocultarPolitica(): any {
    this.setState({ modalPoliticas: false });
  }

  async validaCEP(cep: string): Promise<any> {
    this.setState({ cep });
    const cepTratado: string = cep.replace(/-/g, "").replace(/_/g, "");
    if (cepTratado.length !== 8) {
      this.setState({ consultouCEP: false });
    }

    if (cepTratado.length === 8 && !this.state.consultouCEP) {
      this.setState({ carregando: true });
      return C5UsuarioDAO.getInstance()
        .buscaCep(cepTratado)
        .then((r) => {
          this.setState({
            consultouCEP: true,
            usuarioEndereco: r,
            cidade: r.City,
            uf: r.State,
            logradouro: r.StreetAddress,
            bairro: r.Neighborhood,
            carregando: false
          });
        }).catch((ex) => {
          LogUtil.logObject(ex, typeof ex);
          NavegadorUtil.alerta(this, "CEP não encontrado");
          this.setState({ carregando: false, concluido: true });
        });
    }
  }

  addCamposAcessados(campo: string) {
    const { camposAcessados } = this.state;
    if (camposAcessados.indexOf(campo) === -1) {
      camposAcessados.push(campo);
    }
    this.setState({camposAcessados});
  }

  render(): any {
    const {
      nome,
      sobrenome,
      telefone,
      cpf,
      dataNascimento,
      cep,
      logradouro,
      bairro,
      carregouUsuario,
      numero,
      complemento,
      complementoFlag,
      cidade,
      uf,
      email,
      confirmacaoEmail,
      senha,
      confirmacaoSenha,
      sexo,
      camposAcessados,
      step,
    } = this.state;
    const { modalPoliticas, politicas, carregando, concluido } = this.state;
    let alerta: any = AppState.getAlerta();

    if (!alerta) {
      alerta = {
        exibirModal: false,
      } as AlertaModel;
    }

    return (
      <section className="cadastro">
        <div className="header">
          <div className="back" onClick={() => this.props.history.goBack()}>
            <div>
              <ImagemMenuBack />
            </div>
            <h1>Novo Cadastro</h1>
          </div>
        </div>

        {step === 1 && (
        <div className="features">
          <div>
            <img src={LogoBemQuerer} className="bemquerer" alt='Bem Querer'/>
          </div>
          <div>
            <p>Valores ainda mais atrativos em ofertas</p>
            <p>Preço Verde</p>
            <p>Minha Hora Oba</p>
          </div>
        </div>
        )}

        <div className="steps">
          <div className="steps-nav">
            <div className={`step-nav step-nav-1 ${step === 1 ? "active" : ""}`} onClick={() => this.validaFormulario() && this.setState({step: 1})}>
              <div className="icon">
                <i className="fas fa-user"></i>
              </div>
              <h2>Dados Pessoais</h2>
            </div>
            <div className={`step-nav step-nav-2 ${step === 2 ? "active" : ""}`} onClick={() => this.validaFormulario() && this.setState({step: 2})}>
              <div className="icon">
                <i className="fas fa-map-marker"></i>
              </div>
              <h2>Endereço</h2>
            </div>
            <div className={`step-nav step-nav-3 ${step === 3 ? "active" : ""}`}  onClick={() => this.validaFormulario() && this.setState({step: 3})}>
              <div className="icon">
                <i className="fas fa-lock"></i>
              </div>
              { !carregouUsuario &&
                <h2>Email e Senha</h2>
              }
              { carregouUsuario &&
                <h2>Senha</h2>
              }
            </div>
          </div>
          <div className="content">
            <div className={`step step-1 ${step === 1 ? "active" : ""}`}>
              <FormControl variant="outlined">
                <InputMask
                  mask="999.999.999-99"
                  maskChar="_"
                  value={cpf}
                  onFocus={() => this.addCamposAcessados("cpf") }
                  onChange={(e) => this.setState({ cpf: e.target.value as string })}
                >
                  {(inputProps: any) => (
                    <ObaTextField
                      {...inputProps}
                      variant="outlined"
                      error={(camposAcessados.indexOf("cpf") > -1) && nome.length === 0}
                      label="CPF"
                    ></ObaTextField>
                  )}
                </InputMask>
              </FormControl>
              <FormControl variant="outlined">
                <ObaTextField
                  onChange={(e) => this.setState({ nome: e.target.value as string })}
                  variant="outlined"
                  label="*Nome"
                  onFocus={() => this.addCamposAcessados("nome") }
                  error={(camposAcessados.indexOf("nome") > -1) && nome.length === 0}
                  value={nome}
                />
              </FormControl>
              <FormControl variant="outlined">
                <ObaTextField
                  onChange={(e) =>
                    this.setState({ sobrenome: e.target.value as string })
                  }
                  variant="outlined"
                  label="*Sobrenome"
                  onFocus={() => this.addCamposAcessados("sobrenome") }
                  error={(camposAcessados.indexOf("sobrenome") > -1) && sobrenome.length === 0}
                  value={sobrenome}
                />
              </FormControl>
              <FormControl variant="outlined">
                <InputMask
                  mask="(99) 99999-9999"
                  maskChar="_"
                  value={telefone}
                  onFocus={() => this.addCamposAcessados("telefone") }
                  onChange={(e) =>
                    this.setState({ telefone: e.target.value as string })
                  }
                >
                  {(inputProps: any) => (
                    <ObaTextField
                      {...inputProps}
                      variant="outlined"
                      label="*Celular"
                      error={(camposAcessados.indexOf("telefone") > -1) && telefone.length === 0}
                      ></ObaTextField>
                  )}
                </InputMask>
              </FormControl>
              <FormControl variant="outlined">
                <InputMask
                  mask="99/99/9999"
                  maskChar="_"
                  value={dataNascimento}
                  onFocus={() => this.addCamposAcessados("dataNascimento") }
                  onChange={(e) =>
                    this.setState({ dataNascimento: e.target.value as string })
                  }
                >
                  {(inputProps: any) => (
                    <ObaTextField
                      {...inputProps}
                      variant="outlined"
                      error={(camposAcessados.indexOf("dataNascimento") > -1) && dataNascimento.length === 0}
                      label="*Data nascimento"
                    ></ObaTextField>
                  )}
                </InputMask>
              </FormControl>
              <FormControl variant="outlined">
                <ObaTextField
                  select
                  label="Sexo"
                  inputProps={{ name: "sexo", id: "sexo" }}
                  onChange={(e) => this.setState({ sexo: e.target.value as string })}
                  onFocus={() => this.addCamposAcessados("sexo") }
                  error={(camposAcessados.indexOf("sexo") > -1) && sexo.length === 0}
                  variant="outlined"
                  value={sexo}
                >
                  <MenuItem value="M">Masculino</MenuItem>
                  <MenuItem value="F">Feminino</MenuItem>
                </ObaTextField>
              </FormControl>
              <button
                onClick={()=>{
                  if ( this.validaFormulario() ) {
                    document.documentElement.scrollTop = 0;
                    this.setState({step: 2});
                  } 
                }}
                className="next"
              >
                Próximo <i className="fas fa-arrow-right"></i>
              </button>
            </div>

            <div className={`step step-2 ${step === 2 ? "active" : ""}`}>
              {false && (
              <button
                onClick={()=>{}}
                className="next hide"
              >
                Usar minha localização <i className="fas fa-location-arrow"></i>
              </button>
              )}
              <FormControl variant="outlined">
                <InputMask
                  mask="99999-999"
                  maskChar="_"
                  value={cep}
                  onFocus={() => this.addCamposAcessados("cep") }
                  onChange={(e) => this.validaCEP(e.target.value as string)}
                >
                  {(inputProps: any) => (
                    <ObaTextField
                      {...inputProps}
                      variant="outlined"
                      
                      label="CEP"
                    ></ObaTextField>
                  )}
                </InputMask>
              </FormControl>
              <FormControl variant="outlined">
                <ObaTextField
                  onChange={(e) =>
                    this.setState({ logradouro: e.target.value as string })
                  }
                  onFocus={() => this.addCamposAcessados("logradouro") }
                  variant="outlined"
                  error={(camposAcessados.indexOf("logradouro") > -1) && logradouro.length === 0}
                  label="*Logradouro"
                  value={logradouro}
                />
              </FormControl>
              <FormControl variant="outlined">
                <ObaTextField
                  onChange={(e) =>
                    this.setState({ numero: e.target.value as string })
                  }
                  variant="outlined"
                  onFocus={() => this.addCamposAcessados("numero") }
                  error={(camposAcessados.indexOf("numero") > -1) && (numero === null || (numero.length === 0))}
                  label="*Número"
                  value={numero}
                />
              </FormControl>
              <div className="check-field complemento-flag">
                <input
                  type="checkbox"
                  value="sim"
                  name="complementoFlag"
                  checked={ complementoFlag }
                  onChange={(e) => {
                    this.setState({ complementoFlag: e.target.checked });
                  }}
                />
                <span>
                  Meu endereço não possui complemento.
                </span>
              </div>
              { !complementoFlag &&
              <FormControl variant="outlined">
                <ObaTextField
                  onChange={(e) =>
                    this.setState({ complemento: e.target.value as string })
                  }
                  variant="outlined"
                  label="Complemento"
                  value={ complemento === this.naoTemComplemento ? "" : complemento }
                />
              </FormControl>
              }
              <FormControl variant="outlined">
                <ObaTextField
                  onChange={(e) =>
                    this.setState({ bairro: e.target.value as string })
                  }
                  variant="outlined"
                  label="*Bairro"
                  onFocus={() => this.addCamposAcessados("bairro") }
                  value={bairro}
                />
              </FormControl>
              <FormControl variant="outlined">
                <ObaTextField
                  onChange={(e) =>
                    this.setState({ cidade: e.target.value as string })
                  }
                  variant="outlined"
                  label="Cidade"
                  value={cidade}
                />
              </FormControl>
              <FormControl variant="outlined">
                <ObaTextField
                  onChange={(e) => this.setState({ uf: e.target.value as string })}
                  variant="outlined"
                  label="UF"
                  value={uf}
                />
              </FormControl>
              <button
                onClick={()=>{
                  if ( this.validaFormulario() ) {
                    document.documentElement.scrollTop = 0;
                    this.setState({step: 3});
                  } 
                }}
                className="next "
              >
                Próximo <i className="fas fa-arrow-right"></i>
              </button>
            </div>

            <div className={`step step-3 ${step === 3 ? "active" : ""}`}>
              { !carregouUsuario && 
              <>
                <FormControl variant="outlined">
                  <ObaTextField
                    onChange={(e) => this.setState({ email: e.target.value as string })}
                    type="email"
                    variant="outlined"
                    label="*E-mail"
                    value={email}
                    onFocus={() => this.addCamposAcessados("email") }
                    error={(camposAcessados.indexOf("email") > -1) && email.length === 0}
                    inputProps={carregouUsuario ? { readOnly: true } : {}}
                  />
                </FormControl>
                <FormControl variant="outlined">
                <ObaTextField
                  onChange={(e) => this.setState({ confirmacaoEmail: e.target.value as string })}
                  type="confirmacaoEmail"
                  variant="outlined"
                  label="*Confirmação de e-mail"
                  value={confirmacaoEmail}
                  onFocus={() => this.addCamposAcessados("confirmacaoEmail") }
                  error={(camposAcessados.indexOf("confirmacaoEmail") > -1) && email.length === 0}
                  inputProps={carregouUsuario ? { readOnly: true } : {}}
                />
                </FormControl>
              </>
            }
              <div className="regras-senha">
                Sua senha precisa ter: <br />
                <ul>
                  <li>- Pelo menos 8 caracteres;</li>
                  <li>- Letra maiúscula e minúscula;</li>
                  <li>- Pelo menos um número;</li>
                  {carregouUsuario && (
                    <li>
                      <b>
                        - Não preencha os campos abaixo caso não queira alterar a
                        senha
                      </b>
                    </li>
                  )}
                </ul>
              </div>
              <FormControl variant="outlined">
                <ObaTextField
                  onChange={(e) => this.setState({ senha: e.target.value as string })}
                  type="password"
                  variant="outlined"
                  label="Senha"
                  value={senha}
                />
              </FormControl>
              <FormControl variant="outlined">
                <ObaTextField
                  onChange={(e) =>
                    this.setState({ confirmacaoSenha: e.target.value as string })
                  }
                  type="password"
                  variant="outlined"
                  label="Confirmação Senha"
                  value={confirmacaoSenha}
                />
              </FormControl>
              <div className="check-field politica">
                <input
                  type="checkbox"
                  value="sim"
                  name="politica"
                  onChange={(e) =>
                    this.setState({ aceitacao: e.target.checked })
                  }
                />
                <span>
                  Aceito os <strong onClick={this.exibirTermos}>termos e condições</strong> e contato para ofertas e promoções.
                </span>
              </div>
              <input
                type="button"
                value="Confirmar cadastro"
                onClick={this.cadastrar}
                className="action"
              />
            </div>
          </div>
        </div>

        {politicas && politicas.length > 0 && (
          <ModalPolitica
            hide={this.ocultarPolitica}
            titulo={politicas[0].titulo}
            textoHTML={politicas[0].conteudo}
            visivel={modalPoliticas}
          />
        )}
        <Snackbar
          open={alerta.exibirModal}
          className="info"
          transitionDuration={1000}
          onClose={() => AppState.fecharAlerta(this)}
          autoHideDuration={6000}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{alerta.mensagem}</span>}
        />
        <Rodape parent={this} ativo="Menu"></Rodape>
        <Carregando exibir={carregando} concluido={concluido}></Carregando>
      </section>
    );
  }
}

export default withRouter(Cadastrese);
